import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=8ab9e7d8&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"
import style0 from "./NotFound.vue?vue&type=style&index=0&id=8ab9e7d8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6._iyputc2ruckis4av77ubvklewu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab9e7d8",
  null
  
)

export default component.exports